// extracted by mini-css-extract-plugin
export default {"label":"booking_guarantee_label__RMy-r","card_type":"booking_guarantee_card_type__i0agm"};